import {
  incrementCurrentRenderTime,
  startRenderTime
} from '../../render-timer';
import { reaction } from '../../utils/preact-utils';
import { AdContainerStore } from '../../stores/ad-container.store';
import { RootStore } from '../../stores/root.store';

export class RenderTimeHandler {
  adContainerStore: AdContainerStore;

  constructor({ adContainerStore }: RootStore) {
    this.adContainerStore = adContainerStore;

    reaction(
      () => this.adContainerStore.isViewable.value,
      isViewable => {
        if (isViewable) {
          startRenderTime();
        } else {
          incrementCurrentRenderTime();
        }
      },
      true
    );
  }
}
